import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
declare var $ : any;
// import { VoucherService } from '../voucher.service';

@Component({
	selector: 'app-voucher',
	templateUrl: './voucher.component.html',
	styleUrls: ['./voucher.component.css']
})


export class VoucherComponent implements OnInit {
	url = environment.url

	showForm: FormGroup;
	show = false;
	response : any = null;
	voucher_form : any =[];
	voucher_list: any;

	formData:FormData = new FormData();
	fileName :string;

	selected_date : any = null;

	date:Date=new Date(Date.now());

	


	constructor(  private http : Http, public router: Router) { }

	ngOnInit() {

	 	
		this.showForm = new FormGroup({
			'upload_file' : new FormControl(null,Validators.required)
		});

	}

	// demo(){
		

	// 	let word = this.showForm.value.demo;
	// 	let new_word = word.trim();
	// 	console.log(word);
	// 	console.log(new_word);

	// }





	onFileChange($event) {
		var fileList = $event.target.files;
		console.log(fileList)
		if (fileList.length > 0) {
			console.log("fileList", fileList[0])
			this.formData.append('voucher_file', fileList[0]);

		}
	}



	onUpload(){

		// epoch date

		console.log("form values=",this.showForm.value);
		

		this.show = true;

		const authToken = JSON.parse(localStorage.getItem('user_token'));

		const headers = new Headers ({'Authorization': `${authToken}`});
		const options = new RequestOptions({ headers: headers });
		const path = this.url + '/upload/voucherFile';
		this.http.post(path, this.formData, options)
		.map(response => response.json())
		.subscribe(
			(response) => {
			console.log(response);
			console.log("success response");
			// this.response = JSON.parse(res.json());
			// console.log(this.response.status)
			if (response["status"]){

				this.voucher_list = response['data'];
				console.log("===",Math.round(65.98));

				swal(
					'Voucher Uploaded Successfully',
					'Successfully' ,
					'success'
				);

			}else{
				swal('Voucher Uploading failed','Please Reload the Page','error');
			}
		},
		(error) => console.log(error.json())
		);
		
		this.formData.delete('voucher_file');
		this.showForm.reset();

	}


	voucherPrint(){
		console.log("helloo");
		var data = this.voucher_list;

		console.log(data);

		const authToken = JSON.parse(localStorage.getItem('user_token'));
		const headers = new Headers({'Content-Type': 'application/json', 'Authorization': `${authToken}`});
		const options = new RequestOptions({ headers: headers });
		const path = this.url + '/save/voucherFile';
		this.http.post(path, this.voucher_list, options)
		.map(response => response.json())
		.subscribe(
			(response) => {
			console.log(response);
			console.log("success response");
			if (response["status"]){
				// go to print
		
				var voucher_id = response['voucher_id']['$oid'];
				window.open(this.url+'/print/voucher/'+ voucher_id, '_blank');
				console.log("print successfully");


			}else{
				swal('failed','something went wrong','error');
			}
		},
		(error) => console.log(error)
		);

		// $("tbody tr").remove();
	}




}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/voucher/voucher.component.ts